import { render } from "./AddAdminMd.vue?vue&type=template&id=c1b8badc"
import script from "./AddAdminMd.vue?vue&type=script&lang=js"
export * from "./AddAdminMd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__